var _defs, _circle, _g, _circle2, _line, _path, _path2, _polyline, _path3, _path4, _path5, _circle3, _path6, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWorkstyle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5,.cls-6,.cls-7,.cls-9{fill:none;}.cls-2{fill:#f0f0f0;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#425cc7;}.cls-5,.cls-6,.cls-7{stroke:#002554;}.cls-5,.cls-6,.cls-9{stroke-linecap:round;}.cls-5,.cls-7,.cls-9{stroke-linejoin:round;}.cls-6{stroke-miterlimit:10;}.cls-8{fill:#fff;}.cls-9{stroke:#425cc7;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.68,27.41H15.83l.87-7.09A1.35,1.35,0,0,1,18,19.16h9.53a1,1,0,0,1,1,1.16Z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16,
    cy: 16,
    r: 15.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.76,27.41H16.92l.87-7.09a1.35,1.35,0,0,1,1.3-1.16h9.53a1,1,0,0,1,1,1.16Z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 10.09,
    cy: 12.47,
    r: 3.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1,
    y1: 27.48,
    x2: 31,
    y2: 27.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.7,20.09V27.3H4.05V23.23A3.68,3.68,0,0,1,5.7,20.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5.93,20.09,5.85,27.3H2.94V23.47a3.47,3.47,0,0,1,1.56-3A2.68,2.68,0,0,1,5.93,20.09Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "8.91 21.93 8.91 24.86 14.24 24.86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.66,27.48H27a3.29,3.29,0,0,0,.71-.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.64,24.86h-.4V21.24a4.2,4.2,0,0,0-8.39,0v6.24h8.79a1.31,1.31,0,0,0,0-2.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.68,27.41H15.83l.87-7.09A1.35,1.35,0,0,1,18,19.16h9.53a1,1,0,0,1,1,1.16Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 22.46,
    cy: 23.39,
    r: 0.81
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.59,7.77V9.36a.62.62,0,0,0,.16.41L24,11"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 22.59,
    y1: 5.54,
    x2: 22.59,
    y2: 6.13
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 25.46,
    y1: 6.73,
    x2: 25.04,
    y2: 7.14
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 26.65,
    y1: 9.6,
    x2: 26.06,
    y2: 9.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 25.46,
    y1: 12.47,
    x2: 25.04,
    y2: 12.06
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 22.59,
    y1: 13.66,
    x2: 22.59,
    y2: 13.07
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 18.53,
    y1: 9.6,
    x2: 19.11,
    y2: 9.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 19.72,
    y1: 12.47,
    x2: 20.13,
    y2: 12.06
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 19.72,
    y1: 6.73,
    x2: 20.13,
    y2: 7.14
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 22.59,
    cy: 9.67,
    r: 4.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkstyle);
export default __webpack_public_path__ + "static/media/icon-workstyle.8eef922279ad9664b6992df732f9226d.svg";
export { ForwardRef as ReactComponent };